/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Treatment/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Charges from './Charges/index'
import Discounts from './Discounts/index'
import React from 'react'
import Total from './Total/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Treatment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/Treatment"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let payersTreatmentNameValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'treatment.name',
})
let constantData = 18
let aggregateData = fromAggregate.truncate(payersTreatmentNameValueData, constantData)
let payersTreatmentNameValueData1 = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'treatment.name',
})
let payersTreatmentTotalValueData = fromData.useDataFormat({ viewPath,
context: 'payers',
path: 'treatment.total',
format: fromFormat.numberMoney,
})
let dtColorsBrandGreen = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="Treatment.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-2i9IjI': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="payers.treatment.name"
 data={18}
 aggregate="/Data/aggregate.js truncate"
 text={aggregateData}
 data="payers.treatment.name"
 title={payersTreatmentNameValueData1}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="large"
 color={dtColorsBrandGreen}
 data="payers.treatment.total"
 format="/Data/format.js numberMoney"
 text={payersTreatmentTotalValueData}
/>
</div>
<Discounts
  viewPath={`${viewPath}/Discounts`}
/>
<Charges
  viewPath={`${viewPath}/Charges`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 backgroundColor={dtColorsNeutral300}
/>
<Total
  viewPath={`${viewPath}/Total`}
/>
{children}
</React.Fragment>)
}